<template>
  <div class="rule-wraper">
    <TxButton class="rule text-shu" src="anniu" name="活动规则" @click="is_show = true">活动规则</TxButton>
    <TxDialog v-model="is_show" zIndex="10000" class="dialog-box">
      <div class="rule-container">
        <div class="title t-s-30">活动规则</div>
        <!-- <div class="tab-box">
          <TxButton :src="activeTab === item.value ? 'anniu_4' : 'anniu_4_1'" class="tab-item" v-for="item in tabList"
            :key="item.value" :name="item.name" @click="changeTab(item)">
            {{ item.name }}
          </TxButton>
        </div> -->
        <div class="rule-content">
          <div class="rule-item">
            <div class="desc-content">
              <div> 预约活动时间： 10月22日 12:00 -《天下：万象》上线
              </div>
              <div> 预约红包提现： 10月24日 12:00 -《天下：万象》上线
              </div>
              <div> 活动奖励领取： 《天下：万象》上线 - 上线后30日
              </div>
              <div class="red">*《天下：万象》上线时间请关注后续官方通知
              </div>
            </div>
          </div>
          <div class="rule-item">
            <div class="rule-title">【预约万象得红包】
            </div>
            <div class="desc-content">
              <p> 1、活动期间，少侠在本页面成功预约，即可获得随机金额现金红包一份，<span class="green">最高可暴击888元！</span>
              </p>
              <p> 2、预约红包将在<span class="red">10月24日 12:00</span>开启提现，少侠在提现开启后可根据指引，使用<span class="red">
                  <微信>
                </span>进行红包提现。
              </p>
              <p> 3、请注意：红包提现需要绑定微信，且所绑定的<span class="red">微信账号需已完成实名认证</span>；使用未实名微信提现会导致转账失败，奖励不再补发，请少侠操作前仔细确认。
              </p>
              <p> 4、请注意：本活动中，<span class="red">同一微信账号仅可进行1次预约红包提现</span>，请少侠操作前仔细确认。
              </p>
            </div>
          </div>
          <div class="rule-item">
            <div class="rule-title">【瓜分奖池抽好礼】</div>
            <div class="desc-content">
              <p> 1、活动期间，少侠可通过完成预约、分享、邀请、组队任务获取抽奖次数。
              </p>
              <p> 2、<span class="red fwb">抽奖次数获取途径：</span>
              </p>
              <p> -首次预约得3次
              </p>
              <p> -首次分享得2次
              </p>
              <p> -组团人数超过2人得1次
              </p>
              <p> -每邀请1位好友成功预约得1次（最高可得100次）
              </p>
              <p> 3、消耗获奖次数，可在奖池中抽取<span class="green">iPhone 17
                  pro、玉玑子1/4雕塑、中石化油卡、《万象天成》纪念盒子、现金红包、天下定制玄素版娃衣、百万元宝</span>等丰厚好礼！完整奖池可在活动页面中查看。
              </p>
              <p>
                4、<span
                  class="red fwb">同享机制：</span>抽奖机率触发同享，触发后除了自身获得的奖励外，可额外获得一份同享奖励，同享奖励可赠送给好友领取。每一同享奖励仅可被1位好友领取，从好友处领取的同享奖励会放入已获取奖励中，少侠可自行选择是否带回游戏内。同享奖励触发后<span
                  class="red">有效期为1小时</span>，若在1小时内未分享/未被其他人领取，则同享份额失效。<span class="red">每位少侠仅可领取同一人的同享奖励1次。</span>
              </p>
              <p> 5、活动期间，少侠可从当前所抽取的奖励中，选择<span class="red">6个</span>心仪的奖励（含所领取的同享奖励）放入提取背包进行领取。提取背包包含<span
                  class="red">2个金色格子</span>，以及<span class="red">4个普通格子</span>
              </p>
              <p> -<span class="tdu">金色格子</span>：可提取金色奖励和普通奖励
              </p>
              <p> -<span class="tdu">普通格子</span>：仅可提取普通奖励
              </p>
              <p> 6、预约活动结束时，提取背包将会锁定。若提取背包未填满，且仍有可放入奖品，系统将会选取其中高价值奖励自动补位。
              </p>
              <p> 7、《天下：万象》上线后，少侠可自行选择预约所用账号在天下3/天下贰（包含年度服【弱水三千】/《天下贰·经典版》）的所有服务器中，任选其中1个服务器下的<span
                  class="red">1个角色</span>领取抽奖奖励，<span class="red">同一账号仅可领取1次。</span>
              </p>
              <p> 8、奖励将通过<span class="red">万象端NPC-万象预约大使</span>进行发放，请少侠前往九黎南门找到万象预约大使领取（<span
                  class="red">同实名认证账号仅可领取1份奖励</span>）。
              </p>
              <p> 9、请注意：游戏内奖励（元宝、时装、绑定金、太初原石）不适用于《天下贰·经典版》，在经典版领取将会被替换为其他专属奖励。
              </p>
            </div>

          </div>
          <div class="rule-item">
            <div class="rule-title">
              【好友组队领时装】
            </div>
            <div class="desc-content">
              <p> 1、活动期间，少侠邀请好友加入组队，即可根据组队获得对应奖励，奖励内容将根据组队人数的增加逐步解锁。
              </p>
              <p>2、《天下：万象》上线后，少侠可自行选择预约所用账号在天下3/天下贰（包含年度服【弱水三千】/《天下贰·经典版》）的所有服务器中，任选其中1个服务器下的<span
                  class="red">1个角色</span>领取抽奖奖励，<span class="red">同一账号仅可领取1次。</span>
              </p>
              <p> 3、奖励将通过<span class="red">万象端NPC-万象预约大使</span>进行发放，请少侠前往九黎南门找到万象预约大使领取。
              </p>
              <p> 4、请注意：组队奖励在经典版领取将会被替换为其他专属奖励。
              </p>
              <p> 5、请注意：当队伍人数≥2人时，将不可解散、退出、更换队伍。
              </p>
            </div>
          </div>
          <div class="rule-item">
            <div class="rule-title">
              【预约集结启程礼】
            </div>
            <div class="desc-content">
              <p> 1、活动期间，少侠在本页面成功预约，即可分别获得天下3年度服【弱水三千】及《天下贰·经典版》启程礼各一份。
              </p>
              <p>
                2、请注意：预约启程礼仅可在天下3年度服【弱水三千】及《天下贰·经典版》领取；年度服/经典版上线后，少侠可选择预约所用账号，在年度服下创建的任意1个角色，及经典版中创建的任意1个角色，领取对应启程奖励，<span
                  class="red">同一账号仅可在年度服/经典版分别领取1次。</span>
              </p>
              <p> 3、奖励将通过<span class="red">万象端NPC-万象预约大使</span>进行发放，请少侠前往九黎南门找到万象预约大使领取。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="close-box">
        <TxButton src="gb" name="" @click="closeModal">
        </TxButton>
      </div>
    </TxDialog>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const is_show = ref(false);
const activeTab = ref('choujiang')
const tabList = [
  { name: '抽奖好礼', value: 'choujiang' },
  { name: '玩家共享', value: 'gongxiang' },
  { name: '版本特色', value: 'banben' },
]

const kuangBgImage = computed(() => {
  return {
    'border-image-source': `url(https://g20.gsf.netease.com/20251011-172948/db_9.png )`
  }
})

function changeTab(item) {
  activeTab.value = item.value
}

function closeModal() {
  is_show.value = false
}

</script>
<style lang="scss" scoped>
.red {
  color: #f00;
}

.green {
  color: #33bb33;
}

.tdu {
  text-decoration: underline;
}

.fwb {
  font-weight: bold;
}

.rule {
  position: fixed;
  right: 0px;
  top: 150px;
  z-index: 99;
  color: #e8e8e8;
  font-size: 20px;
}

.dialog-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rule-container {
  // width: 719px;
  // min-height: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include bg('db_9-2');
  // 上 右 下 左
  // border: 0px solid transparent;
  // height: fit-content;
  // border-image-slice: calc(500 / 2) calc(719 / 2) calc(50) calc(719 / 2);
  // border-image-width: 500px 719px 100px 719px;
  // border-image-repeat: repeat;
  padding-top: 80px;
  padding-bottom: 70px;

  .title {
    color: #fff;
    margin-bottom: 50px;
  }

  .tab-box {
    display: flex;
    align-items: center;

    .tab-item {
      margin-right: 5px;
      color: #fff;
      font-size: 24px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .rule-content {
    height: 900px;
    width: 626px;
    // background-color: #ced0d0;
    border-radius: 0 0 6px 6px;
    box-sizing: border-box;
    padding: 20px;
    overflow: hidden;
    overflow-y: auto;
    color: #202631;
    font-size: 24px;

    .rule-item {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .rule-title {
        margin-bottom: 5px;
        font-weight: bold;
      }

      .desc-content {
        p {
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .close-box {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;

    .close-icon {
      color: #fff;
    }
  }
}
</style>
